import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { PortalApiService } from './../shared/services/api/portal-api.service';
import { finalize } from 'rxjs/operators';

const apiEndpoints = {
  emailOptOutProfile: 'practitioneranon'
};

@Injectable()
export class UnsubscribeService {

  constructor(
    private portalApiService: PortalApiService
    ) { }
    getEmailProfile(guid: string, email: string): Observable<any> {
      return this.portalApiService.get(apiEndpoints.emailOptOutProfile.concat(`/${guid}?x=${email}`))
        .pipe(finalize(() => null));
    }

    updateEmailProfile(guid:string, email: string, optOutInfo: any):Observable<any> {
      return this.portalApiService.post(apiEndpoints.emailOptOutProfile.concat(`/${guid}?x=${email}`), optOutInfo);
    }

}
